import axios from 'axios'

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

  
  // Function to set the token
  export const setAuthToken = (token) => {
    if (token) {
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete apiClient.defaults.headers.common['Authorization'];
    }
  };
  
  export default apiClient;

